import { Capacitor } from '@capacitor/core';

function remapValue(mobileValue, webValue, internalValue) {
  if (Capacitor.isNativePlatform()) {
    return mobileValue;
  }

  // Controlla se c'è il flag per il login interno nel sessionStorage
  const isInternalLogin = window.sessionStorage?.getItem('internalLogin') === 'true';
  if (internalValue && isInternalLogin) {
    return internalValue;
  }

  return webValue;
}

const configMapping = {
  REDIRECT_PATH_LOGIN: {
    web: process.env.REDIRECT_PATH_LOGIN,
    mobile: process.env.REDIRECT_PATH_LOGIN_APP,
    internal: process.env.PATH_LOGIN,
  },
  API_REST_IAM: {
    web: process.env.API_REST_IAM,
    mobile: process.env.API_REST_IAM_MOBILE,
  },
  API_NPG: {
    web: process.env.API_NPG,
  }
};

const appEnvRemap = Object.keys(configMapping).reduce((acc, key) => {
  acc[key] = remapValue(
    configMapping[key].mobile,
    configMapping[key].web,
    configMapping[key].internal
  );
  return acc;
}, {});

// Funzioni di utilità per gestire il flag del login interno
export const setInternalLogin = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.setItem('internalLogin', 'true');
  }
};

export const setCmsLogin = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.setItem('internalLogin', 'false');
  }
};

export const isInternalLogin = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return window.sessionStorage.getItem('internalLogin') === 'true';
  }
  return false;
};

export default appEnvRemap;
